'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true,
});

exports.useGetBaseColorFromProps = void 0;

var react_1 = require('react');

var components_1 = require('../constants/components');

var useThemeContext_1 = require('./useThemeContext');

var useGetBaseColorFromProps = function useGetBaseColorFromProps(color, opacity) {
  var themeConfig = useThemeContext_1.useThemeContext().themeConfig;
  var colorOpacity = opacity && opacity >= 0 && opacity <= 1 ? opacity : 1;
  var baseColors = react_1.useMemo(
    function () {
      var _a;

      return (
        (_a = {}),
        (_a[components_1.BASE_COLORS.primary1] = themeConfig.baseColors.primary1(colorOpacity)),
        (_a[components_1.BASE_COLORS.primary2] = themeConfig.baseColors.primary2(colorOpacity)),
        (_a[components_1.BASE_COLORS.secondary1] = themeConfig.baseColors.secondary1(colorOpacity)),
        (_a[components_1.BASE_COLORS.secondary2] = themeConfig.baseColors.secondary2(colorOpacity)),
        _a
      );
    },
    [themeConfig, colorOpacity]
  );
  return color ? baseColors[color] : '';
};

exports.useGetBaseColorFromProps = useGetBaseColorFromProps;
